export default {
  marshal: (data) => {
    let allElements = [];
    (data.steps || []).forEach((step) => {
      (step.sections || []).forEach((section) => {
        allElements = [...allElements, ...(section.elements || [])];
      });
    });
    return allElements
      .filter((element) => element.isCustomField)
      .map((element) => element.fieldCode);
  },
};
